import axios from 'axios'
import qs from "qs"
import {
	Toast
} from 'vant'
import router from '@/router'
import api from "../interface/index"
//import {Notify} from 'vant'
import {
	Dialog
} from 'vant';

let loadingCount = 0;

export const showLoading = () => {
	if (loadingCount <= 0) {
		Toast.loading({
			// mask: true,
			duration: 20000
		})
	}
	loadingCount++
}

export const hideLoading = () => {
	loadingCount--;
	if (loadingCount <= 0) {
		Toast.clear()
		loadingCount = 0
	}
};

let ssid = localStorage.getItem('ssid');

export default async (url, data, opt, isLoad = true) => {
	url = api.commonUrl + "/api" + url;
	return axios.post(url, data, {
		headers: {
		  'Content-Type': 'multipart/form-data'
		}
	  }).then(response => {
		if (response.data.status === 'success') {
		  // 文件上传成功处理
		  return response.data.filePath
		} else {
		  // 文件上传失败处理
		  
		}
	  }).catch(error => {
		
	  });
}
